import React from "react";
import styles from "@/styles/desktop/Footer.module.scss";

type FooterProps = {
  logoSrc: string;
  companyInfo: string;
  copyrightInfo: string;
  excellenceLogoSrc: string;
  safetyLogoSrc: string;
  safetyText: string;
};

const Footer: React.FC<FooterProps> = ({
  logoSrc,
  companyInfo,
  copyrightInfo,
  excellenceLogoSrc,
  safetyLogoSrc,
  safetyText,
}) => (
  <footer className={styles.footer}>
    <div className={styles.container}>
      <div className={styles.companyInfo}>
        <img
          width={400}
          height={400}
          loading="lazy"
          src={logoSrc}
          alt="Company logo"
          className={styles.logo}
        />
        <div className={styles.info}>{companyInfo}</div>
        <div className={styles.copyright}>{copyrightInfo}</div>
      </div>
      <div className={styles.excellence}>
        <img
          width={800}
          height={400}
          loading="lazy"
          src={excellenceLogoSrc}
          alt="Kyoto Excelência que te move"
          className={styles.excellenceLogo}
        />
      </div>
      <div className={styles.safety}>
        <img
          width={400}
          height={400}
          loading="lazy"
          src={safetyLogoSrc}
          alt="Safety logo"
          className={styles.logo}
        />
        <div className={styles.text}>{safetyText}</div>
      </div>
    </div>
  </footer>
);

export default Footer;
